import React, { useState } from 'react';
import { Carousel, Row, Col, Button } from 'react-bootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import './CarousalComponent.css'

export const CarousalComponent = () => {

  const [startIndex, setStartIndex] = useState(0); // Start index for displaying content items

  const moveNext = () => {
    if (startIndex < 2) { // Assuming you have 3 items (0-indexed)
      setStartIndex(startIndex + 1);
    }
  };

  const movePrev = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };

  const renderContent = () => {
    return (
      <>
        <Row className={startIndex === 0 ? '' : 'd-none'}>
          <Col style={{borderLeft:"1px solid black"}}>
            <div className="text-center usecase-redefine-content">
              <h5>Knowledge Base Enrichment</h5>
              <p>Invoke AI lens by searching for characteristic names 
              and gain in-depth insights into your search query.</p>
            </div>
            </Col>
            <Col style={{borderLeft:"1px solid black", borderRight:"1px solid black"}}>
            <div className="text-center usecase-redefine-content">
              <h5>Streamlined Workflow Management</h5>
              <p>Have a Holistic view of timelines for each record/request, progress </p>
            </div>
          </Col>
          
        </Row>
        <Row className={startIndex === 1 ? '' : 'd-none'}>
          <Col style={{borderLeft:"1px solid black"}}>
            <div className="text-center usecase-redefine-content">
              <h5>Streamlined Workflow Management</h5>
              <p>tracking, navigation, research requests & highlight duplicates.</p>
            </div>
          </Col> 
          <Col style={{borderLeft:"1px solid black", borderRight:"1px solid black"}}>
            <div className="text-center usecase-redefine-content">
              <h5>Third Slide Label</h5>
              <p>Content for the third slide.</p>
            </div>
          </Col>
        </Row>
        <Row className={startIndex === 2 ? '' : 'd-none'}>
        <Col style={{borderLeft:"1px solid black"}}>
            <div className="text-center usecase-redefine-content">
              <h5>Third Slide Label</h5>
              <p>Content for the third slide.</p>
            </div>
          </Col>
          <Col style={{borderLeft:"1px solid black", borderRight:"1px solid black"}}>
            <div className="text-center usecase-redefine-content">
              <h5>fourth Slide Label</h5>
              <p>Content for the third slide.</p>
            </div>
          </Col>
        </Row>
      </>
    );
  };
  return (
    <div className='p-4'>
      {renderContent()}
      <Row className="mt-3">
        <Col className="d-flex justify-content-between" style={{marginTop:'-5.2rem'}} >
          <ArrowLeftIcon variant="primary" onClick={movePrev} disabled={startIndex === 0} style={{height:'3rem',width:'3rem', marginLeft:'-2.5rem'}}>
            Previous
          </ArrowLeftIcon>
          <ArrowRightIcon variant="primary" onClick={moveNext} disabled={startIndex === 2} style={{height:'3rem',width:'3rem', marginRight:'-2.5rem'}}>
            Next
          </ArrowRightIcon>
        </Col>
      </Row>
    </div>
  )
}
